const styles = {
  chip: {
    margin: '5px'
  }
};

export default styles;
